
export default function fooFromUtilsPackage () {
  console.log('++run test utils++');
}
